import { Conversation } from "./Conversation"
import "./index.css"

export function App() {
	return (
		<div className="app">
			<Conversation />
		</div>
	)
}

export default App
